<template>
  <ReviewStep
    page-title=""
    data-testid="new-transfer-bank-selection"
    title="Para qual conta você deseja transferir?"
    head="Transferir"
    subtitle="Escolha uma conta da sua lista ou adicione uma nova conta"
    @back="goBackStep"
  >
    <Row
      v-for="(bank, index) in bankAccounts"
      :key="index"
      data-testid="bank-account"
      has-interaction
      :has-line="false"
      @click="handleClickBankAccount(bank)"
    >
      <template #icon-left>
        <InitialAvatarImage
          :alt="bank.bankCode"
          :image="bank.bankCode"
          size="medium"
        />
      </template>
      <template #top-left>
        <p>{{ bank.bankName }}</p>
      </template>
      <template #bottom-left>
        <p>Agência {{ bank.agency.formatted }}</p>
        <p>Conta {{ bank.accountNumber.formatted }}</p>
      </template>
    </Row>
    <Row
      has-interaction
      :has-line="false"
      left-title="Adicionar outra conta"
      @click="addNewAccount"
    >
      <template #icon-left>
        <InitialAvatarIcon icon="EF0011" size="medium" />
      </template>
    </Row>
  </ReviewStep>
</template>

<script lang="ts">
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import {
  ReviewStep,
  Row,
  InitialAvatarImage,
  InitialAvatarIcon
} from '@warrenbrasil/nebraska-web';
import { ENewTransferSteps } from '@/modules/transaction/views/NewTransfer/helpers/types';
import { IBankAccount } from '@/modules/transaction/services/new-transfer';

@Component({
  components: {
    ReviewStep,
    Row,
    InitialAvatarImage,
    InitialAvatarIcon
  }
})
export default class NewTransferBankSelection extends Vue {
  @Prop({ type: Array, required: true })
  readonly bankAccounts!: IBankAccount[];

  @Emit('bank-account-selected')
  emitBankAccount(_bank: IBankAccount) {
    // Atualiza o banco selecionado
  }

  @Emit('change-step')
  emitChangeStep(_step: ENewTransferSteps) {
    // Muda para o step emitido
  }

  handleClickBankAccount(bank: IBankAccount) {
    this.emitBankAccount(bank);
    this.emitChangeStep(ENewTransferSteps.REVIEW);
  }

  addNewAccount() {
    this.$router.push({ name: 'user-account' });
  }

  goBackStep() {
    this.emitChangeStep(ENewTransferSteps.AMOUNT_SELECTION);
  }
}
</script>
